import React, {Component} from 'react';
import './styles/Footer.css';

import {NavLink} from 'react-router-dom';
import links from '../_Utilities/nav/links';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const socialLinks = [
    {
        icon: 'fab:instagram',
        href: 'https://www.instagram.com/d18gradshow/'
    },
    {
        icon: 'fab:facebook',
        href: 'https://www.facebook.com/events/248463649351015/'
    }
];

class Footer extends Component {
    render() {
        return (
            <div className={'footer__container'}>
                <div className={'footer__content'}>
                    <div className={'footer__row'}>
                        <a href={'https://sydney.edu.au/'}>
                            <div className={'footer__logo'}></div>
                        </a>
                        <nav className={'footer__links'}>
                            {links.map((link, i) => {
                                return <NavLink key={i} className={'footer__link'}
                                                activeClassName={'footer__link--active'}
                                                to={`/${link.href}`}>{link.title}</NavLink>
                            })}
                        </nav>
                    </div>
                    <div className={'footer__separator'}>
                    </div>
                    <div className={'footer__row'}>
                        <span
                            className={'fineprint fineprint--grey'}>Copyright &copy; 2018 D18 • All Rights Reserved</span>
                        <div className={'footer__links footer__links--social'}>
                            {socialLinks.map((link, i) => {
                                let icons = link.icon.split(':');
                                return <li key={i}>
                                    <a href={link.href} target={'_blank'} style={{backgroundImage: link.icon}}>
                                        <FontAwesomeIcon className={'icon icon--social icon--white'} icon={icons}/>
                                    </a>
                                </li>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;